Vue.component('v-collapse', {
  data: function () {
    return {
      show: false
    }
  },
  methods: {
    toggle: function () {
      this.show = !this.show
    }
  },
  template: `
    <div v-bind:class="['collapse', {'collapse--opened': show}]">
        <div class="collapse__head flex" v-on:click="toggle">
            <div class="collapse__name flex-auto">
                <div class="collapse--bounded">
                    <slot name="head"/>
                </div>
            </div>
            <div class="collapse__arrow flex-none">
                <svg width="24" height="12">
                    <use xlink:href="#svg-arrow-up-toggle-icon" />
                </svg>
            </div>
        </div>
        <transition name="collapse">
          <div v-if="show" class="collapse__content">
              <div>
                  <slot name="content"/>
              </div>
              <slot name="links"/>
          </div>
        </transition>
    </div>
  `
})
